import { props } from "@ngrx/store";
import { Vector3 } from "three";
import { Entity } from "./entity.model";
import { createNetworkActionGroup } from "../network-action-creator/networkActionCreator";
import {ReactionProperties} from "./component-properties-dto/reactions.properties.dto";

export const entityActions = createNetworkActionGroup({
  source: "Entity",
  events: {
    Created: props<{ entity: Entity }>(),
    Found: props<{ entity: Entity }>(),
    Destroyed: props<{ id: string }>(),
    Updated: props<{ entity: Entity }>(),
    Moved: props<{ entityId: string; oldPos: Vector3; newPos: Vector3 }>(),
    "Updated Reactions": props<{ entityId: string; newReactionProperties: ReactionProperties }>(),
  },
});

export const propertyActions = createNetworkActionGroup({
  source: "Property",
  events: {
    Created: props<{ entityId: string; key: string; value: any }>(),
    Destroyed: props<{ entityId: string; key: string }>(),
    Changed: props<{
      entityId: string;
      key: string;
      oldValue: any;
      value: any;
    }>(),
  },
});

